
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.86 10.151a4.077 4.077 0 004.08-4.075A4.078 4.078 0 0012.86 2a4.078 4.078 0 00-4.08 4.076 4.078 4.078 0 004.08 4.075zm2.856.716h-.532a5.56 5.56 0 01-4.647 0h-.533a4.283 4.283 0 00-4.284 4.28v1.325A1.53 1.53 0 007.25 18h11.22A1.53 1.53 0 0020 16.472v-1.325a4.283 4.283 0 00-4.284-4.28z","fill":"#191F2D"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.378 5A.378.378 0 002 5.378V7H.378A.378.378 0 000 7.378v1.244C0 8.83.17 9 .378 9H2v1.622c0 .209.17.378.378.378h1.244c.209 0 .378-.17.378-.378V9h1.622C5.83 9 6 8.83 6 8.622V7.378A.378.378 0 005.622 7H4V5.378A.378.378 0 003.622 5H2.378z","fill":"#191F2D"}})])
          )
        }
      }
    